import { createInactivePage } from 'modules/funnels/funnel/api/funnel-api'
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel'
import InactiveIcon from 'modules/funnels/funnel/icons/inactive-icon'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import React, { useState } from 'react'
import { Loader } from 'shared/components/loader'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url'

interface InactivePageProps {
  funnelId: FunnelId
}

function InactivePage({ funnelId }: InactivePageProps) {
  const { t } = useLocoTranslation()
  const { funnel, mutateFunnel } = useFunnel(funnelId)
  const [isFetching, setIsFetching] = useState(false)
  const handleClickInactivePage = async () => {
    if (funnel) {
      if (funnel.inactivePage) {
        window.location.assign(getPageEditorUrl(funnel.inactivePage.id))
      } else {
        setIsFetching(true)
        const response = await createInactivePage(funnelId)
        const inactivePageId = response.data.inactivePage.id
        await mutateFunnel(data => {
          if (data) {
            return { ...data, inactivePage: { id: inactivePageId } }
          }
        }, false)
        setIsFetching(false)
        window.location.assign(getPageEditorUrl(inactivePageId))
      }
    }
  }

  return (
    <li
      className={
        'hover:bg-brand-primary/[0.06] border-[rgb(var(--text-primary))]/20 flex cursor-pointer gap-3 border-b-[1px] px-[15px] py-[15px] last:border-b-transparent'
      }
      onClick={handleClickInactivePage}
    >
      {isFetching ? (
        <div className={'flex w-full justify-center'}>
          <Loader />
        </div>
      ) : (
        <>
          <InactiveIcon className="shrink-0" />
          <div className="flex flex-col flex-wrap">
            <span className="text-base font-bold">{t('dashboard.funnel.inactive_page')}</span>
            <span className="text-sm font-normal">
              {t('dashboard.funnel.inactive_page_description')}
            </span>
          </div>
        </>
      )}
    </li>
  )
}

export default InactivePage
